// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__2CpUw"};